module.exports = __webpack_public_path__ + "img/tarj2-3.a4b40ea6.png";